const formatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatCurrency(value: number | string | null | undefined) {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  const amount = typeof numberValue === 'number' && Number.isFinite(numberValue) ? numberValue : 0;
  return formatter.format(amount);
}
